import { EmptyValue } from "@bcc/components/ui/empty-value";
import { findShipToInfoForCountry } from "@bcc/lib/products/ship-to-countries";
import { formatDate } from "@client-shared";
import { useVendorContext } from "@client-shared/providers/vendor";
import { CellContext } from "@tanstack/react-table";
import { setExpectedOutOfStockCellTestId } from "../products-table.utils";
import { VariantWithProductData } from "../types";

export const ExpectedOutOfStockCellMarkup = (props: CellContext<VariantWithProductData, unknown>) => {
  const [{ currentVendor }] = useVendorContext();
  const data = props.row.original;
  const isShortTerm = data.term === "Short";

  const dateToShow = findShipToInfoForCountry(data.shipToInfo, currentVendor?.countryCode)?.expectedOutOfStockDate;

  return (
    <span className="text-sm" data-testid={setExpectedOutOfStockCellTestId(props.row.index)}>
      {isShortTerm && dateToShow ? formatDate(dateToShow) : <EmptyValue />}
    </span>
  );
};
